import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { MOBILE, LARGEDESKTOP } from '@constants/responsive'
import { indexMap } from '@helpers'
import './TierBlockTitle.module.scss'

class TierBlockTitle extends Component {
  state = {
    responsiveView: false,
    desktop: false,
    spacer: 17,
    offset: 10,
    offsetPretitle: 4
  }

  componentDidMount () {
    window.addEventListener('resize', this.resize)
    this.resize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', () => {})
  }

  resize = () => {
    const responsiveView = window.innerWidth < MOBILE
    const desktopView = window.innerWidth < LARGEDESKTOP

    this.setState({
      responsiveView,
      desktopView
    })

    if (desktopView) {
      this.setState({
        spacer: 12,
        offset: 10,
        offsetPretitle: 7
      })
    } else {
      this.setState({
        spacer: 17,
        offset: 10,
        offsetPretitle: 4
      })
    }
  }

  render () {
    const { titles, preTitle, withAnimation, wrapTitleAndPreTitleInH1 } = this.props
    const { responsiveView, spacer, offset, offsetPretitle } = this.state

    const TagName = wrapTitleAndPreTitleInH1 ? 'h1' : 'span'

    return (
      <TagName styleName='titles'>
        {indexMap((title, index) => {
          const isPreTitle = index === 0 && preTitle
          const style = {}

          if (!responsiveView) {
            style.marginLeft = (titles.length - 1 - index) * spacer + (isPreTitle ? offsetPretitle : offset)
          }

          return (
            <span
              styleName='titleBlock'
              style={style}
              key={index}
              className={classnames(`delay-${index * 100}ms`, {
                animated: withAnimation
              })}
              data-animation='fadeInLeft'
            >
              <span styleName={classnames('titleWrapper', { preTitle: isPreTitle })}>
                <span styleName={classnames('title', { preTitle: isPreTitle })} key={index}>{title}<span styleName='dNone'>&nbsp;</span></span>
              </span>
            </span>
          )
        }, titles)}
      </TagName>
    )
  }
}

TierBlockTitle.propTypes = {
  titles: PropTypes.array,
  preTitle: PropTypes.bool,
  withAnimation: PropTypes.bool
}

TierBlockTitle.defaultProps = {
  titles: [],
  preTitle: false,
  withAnimation: false
}

export default TierBlockTitle



// WEBPACK FOOTER //
// ./src/components/TierBlockTitle/TierBlockTitle.js